import { Action } from '@ngrx/store';
import { Location } from '../location/location.model';

export enum LocationApiActionTypes {
  LoadLocationsApi = '[Location API] Load Locations',
  LoadLocationsSuccessApi = '[Location API] Load Locations Success',
  LoadLocationsFailureApi = '[Location API] Load Locations Failure',
  LoadLocationApi = '[Location API] Load Location',
  LoadLocationSuccessApi = '[Location API] Load Location Success',
  LoadLocationFailureApi = '[Location API] Load Location Failure',
  CreateLocationApi = '[Location API] Create Location',
  CreateLocationSuccessApi = '[Location API] Create Location Success',
  CreateLocationFailureApi = '[Location API] Create Location Failure',
  UpdateLocationApi = '[Location API] Update Location',
  UpdateLocationSuccessApi = '[Location API] Update Location Success',
  UpdateLocationFailureApi = '[Location API] Update Location Failure',
  DeleteLocationApi = '[Location API] Delete Location',
  DeleteLocationSuccessApi = '[Location API] Delete Location Success',
  DeleteLocationFailureApi = '[Location API] Delete Location Failure',
  BulkLocationApi = '[Location API] Bulk Location',
  BulkLocationSuccessApi = '[Location API] Bulk Location Success',
  BulkLocationFailureApi = '[Location API] Bulk Location Failure',
  UpdateLocationStatusApi = '[Location API] Update Location Status',
  UpdateLocationStatusSuccessApi = '[Location API] Update Location Status Success',
  UpdateLocationStatusFailureApi = '[Location API] Update Location Status Failure',
}

export class LoadLocationsApi implements Action {
  readonly type = LocationApiActionTypes.LoadLocationsApi;
  constructor(public payload: { params: any } = { params: {} }) {}
}

export class LoadLocationsSuccessApi implements Action {
  readonly type = LocationApiActionTypes.LoadLocationsSuccessApi;
  constructor(public payload: { locations: Location[] }) {}
}

export class LoadLocationsFailureApi implements Action {
  readonly type = LocationApiActionTypes.LoadLocationsFailureApi;
  constructor(public payload: { message: string }) {}
}

export class LoadLocationApi implements Action {
  readonly type = LocationApiActionTypes.LoadLocationApi;
  constructor(public payload: { id: string }) {}
}

export class LoadLocationSuccessApi implements Action {
  readonly type = LocationApiActionTypes.LoadLocationSuccessApi;
  constructor(public payload: { location: Location }) {}
}

export class LoadLocationFailureApi implements Action {
  readonly type = LocationApiActionTypes.LoadLocationFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class CreateLocationApi implements Action {
  readonly type = LocationApiActionTypes.CreateLocationApi;
  constructor(public payload: { location: Location }) {}
}

export class CreateLocationSuccessApi implements Action {
  readonly type = LocationApiActionTypes.CreateLocationSuccessApi;
  constructor(public payload: { location: Location }) {}
}

export class CreateLocationFailureApi implements Action {
  readonly type = LocationApiActionTypes.CreateLocationFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class UpdateLocationApi implements Action {
  readonly type = LocationApiActionTypes.UpdateLocationApi;
  constructor(public payload: { location: Location }) {}
}

export class UpdateLocationSuccessApi implements Action {
  readonly type = LocationApiActionTypes.UpdateLocationSuccessApi;
  constructor(public payload: { location: Location }) {}
}

export class UpdateLocationFailureApi implements Action {
  readonly type = LocationApiActionTypes.UpdateLocationFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class DeleteLocationApi implements Action {
  readonly type = LocationApiActionTypes.DeleteLocationApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteLocationSuccessApi implements Action {
  readonly type = LocationApiActionTypes.DeleteLocationSuccessApi;
  constructor(public payload: { id: string }) {}
}

export class DeleteLocationFailureApi implements Action {
  readonly type = LocationApiActionTypes.DeleteLocationFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export class BulkLocationApi implements Action {
  readonly type = LocationApiActionTypes.BulkLocationApi;
  constructor(public payload: { correlation_id: string; items: Location[] }) {}
}

export class BulkLocationSuccessApi implements Action {
  readonly type = LocationApiActionTypes.BulkLocationSuccessApi;
  constructor(public payload: { correlation_id: string }) {}
}

export class BulkLocationFailureApi implements Action {
  readonly type = LocationApiActionTypes.BulkLocationFailureApi;
  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class UpdateLocationStatusApi implements Action {
  readonly type = LocationApiActionTypes.UpdateLocationStatusApi;
  constructor(public payload: { location: Location }) {}
}
export class UpdateLocationStatusSuccessApi implements Action {
  readonly type = LocationApiActionTypes.UpdateLocationStatusSuccessApi;
  constructor(public payload: { location: Location }) {}
}

export class UpdateLocationStatusFailureApi implements Action {
  readonly type = LocationApiActionTypes.UpdateLocationStatusFailureApi;
  constructor(public payload: { id: string; message: string }) {}
}

export type LocationApiActions =
  | LoadLocationsApi
  | LoadLocationsSuccessApi
  | LoadLocationsFailureApi
  | LoadLocationApi
  | LoadLocationSuccessApi
  | LoadLocationFailureApi
  | CreateLocationApi
  | CreateLocationSuccessApi
  | CreateLocationFailureApi
  | UpdateLocationApi
  | UpdateLocationSuccessApi
  | UpdateLocationFailureApi
  | DeleteLocationApi
  | DeleteLocationSuccessApi
  | DeleteLocationFailureApi
  | BulkLocationApi
  | BulkLocationSuccessApi
  | BulkLocationFailureApi
  | UpdateLocationStatusApi
  | UpdateLocationStatusSuccessApi
  | UpdateLocationStatusFailureApi;
